import { EsConfigMap, CodeSystem } from './types'
import icd10Config from './codeSystemConfigs/icd10Config'
import admConfig from './codeSystemConfigs/admConfig'
import icpc2Config from './codeSystemConfigs/icpc2Config'
import norpatConfig from './codeSystemConfigs/norpatConfig'
import nkpkConfig from './codeSystemConfigs/nkpkConfig'
import phbuConfig from './codeSystemConfigs/phbuConfig'

const defaultConfig: EsConfigMap = {
	[CodeSystem.Adm]: admConfig,
	[CodeSystem.Icd10]: icd10Config,
	[CodeSystem.Icpc2]: icpc2Config,
	[CodeSystem.Norpat]: norpatConfig,
	[CodeSystem.Nkpk]: nkpkConfig,
	[CodeSystem.Phbu]: phbuConfig,
}

export default defaultConfig
